import React from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import DropdownMenu from "../../../../universal/dropdown-menu";

import "./style.scss";
import { Title } from "../../../../library/title";

const Index = () => {
  const loading = useSelector((state) => state.overview.fetchRevenue.loading);

  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );
  const userLoading = useSelector(
    (state) => state.user.fetchUserDetails.loading
  );

  const selectionYears = useSelector(
    (state) => state && state.overview.selectionYears.status
  );
  const activeSelectionYear = useSelector(
    (state) => state.overview.activeSelectionYear
  );

  const renderActiveDisplay = () => {
    if (selectedCompany && !loading && activeSelectionYear) {
      return activeSelectionYear;
    } else {
      if (!userLoading && !selectedCompany) {
        return "Ingen";
      } else {
        return "Laster";
      }
    }
  };

  const selectOptions = () => {
    if (selectionYears) {
      const result = [];
      for (var year in selectionYears) {
        const item = {
          title: selectionYears[year],
          key: selectionYears[year],
          active: activeSelectionYear === selectionYears[year],
          action: null,
        };
        result.push(item);
        return result;
      }
    } else {
      return [];
    }
  };

  const renderToggle = () => {
    return (
      <Dropdown.Toggle
        disabled={loading || (!userLoading && !selectedCompany) ? true : false}
        id="dropdown-filter"
      >
        {renderActiveDisplay()} <i class="fad arrow fa-angle-down"></i>
      </Dropdown.Toggle>
    );
  };

  return (
    <Row className="dashboard-revenue-upper-row">
      <Col className="text-left title-col my-auto">
        <Title size="regular">Inntekter</Title>
      </Col>
      <Col className="text-right button-col my-auto">
        <DropdownMenu
          type="text-purple"
          toggle={renderToggle()}
          title="Velg tidsperiode"
          options={selectOptions()}
        />
      </Col>
    </Row>
  );
};

export default Index;
